// extracted by mini-css-extract-plugin
export var colorSquare = "_tw-0";
export var danger = "_tw-5";
export var lightPink = "_tw-8";
export var neutralBlue = "_tw-7";
export var neutralYellow = "_tw-6";
export var normal = "_tw-1";
export var primary = "_tw-2";
export var primaryLight = "_tw-3";
export var solidBlack = "_tw-g";
export var solidGreen = "_tw-b";
export var solidLightBlue = "_tw-d";
export var solidNavy = "_tw-c";
export var solidOrange = "_tw-f";
export var solidPink = "_tw-e";
export var solidRed = "_tw-9";
export var solidYellow = "_tw-a";
export var success = "_tw-4";